import * as Yup from 'yup';
import i18next from 'i18next';
import { ClienteEnum } from '../../../api/models/Enums';
import { isMarket } from '../../../utils/markets';
import { Markets } from '../../../types';

export const validationsLeadForm = Yup.object().shape({
	Cliente__c: Yup.string().required(i18next.t('client_type_mandatory')),
	Email: Yup.string()
		.email(i18next.t('email_not_valid'))
		.required(i18next.t('email_mandatory')),
	Phone: Yup.string()
		.matches(
			/^\+?\d{1,3}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
			i18next.t('phone_not_valid')
		)
		.required(i18next.t('phone_mandatory')),
	City: Yup.string().required(i18next.t('city_mandatory')),
	Partita_Iva__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) =>
			[ClienteEnum.Azienda, ClienteEnum.Libero_Professionista].includes(value),
		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.required(i18next.t('required_field'))
					.length(11, i18next.t('business_fiscal_code_length_error_11_chars'))
					.matches(
						/^\d{11}$/,
						i18next.t('business_fiscal_code_length_error_11_chars')
					);
			}
			if (isMarket(Markets.es)) {
				return schema
					.required(i18next.t('required_field'))
					.length(9, i18next.t('business_fiscal_code_length_error_9_chars'));
			}
			return schema.required(i18next.t('required_field'));
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	Company: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Azienda,
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	Codice_Fiscale__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Privato,

		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.required(i18next.t('required_field'))
					.length(
						16,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					)
					.matches(
						/^[A-Z0-9]{16}$/,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					);
			}
			if (isMarket(Markets.es)) {
				return schema
					.required(i18next.t('required_field'))
					.length(9, i18next.t('codice_fiscale_format_error_9_chars'));
			}
			return schema.required(i18next.t('required_field'));
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	FirstName: Yup.string().when('Clente__c', {
		is: (value: ClienteEnum) =>
			[ClienteEnum.Libero_Professionista, ClienteEnum.Privato].includes(value),
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	LastName: Yup.string().required(i18next.t('required_field')),
});

export const validationsLeadEditForm = Yup.object().shape({
	Cliente__c: Yup.string().required(i18next.t('client_type_mandatory')),
	Email: Yup.string()
		.email(i18next.t('email_not_valid'))
		.required(i18next.t('email_mandatory')),
	Phone: Yup.string()
		.matches(
			/^\+?\d{1,3}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
			i18next.t('phone_not_valid')
		)
		.required(i18next.t('phone_mandatory')),
	City: Yup.string().required(i18next.t('city_mandatory')),
	Partita_Iva__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) =>
			[ClienteEnum.Azienda, ClienteEnum.Libero_Professionista].includes(value),
		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.length(11, i18next.t('business_fiscal_code_length_error_11_chars'))
					.matches(
						/^\d{11}$/,
						i18next.t('business_fiscal_code_length_error_11_chars')
					);
			}
			if (isMarket(Markets.es)) {
				return schema.length(9, i18next.t('business_fiscal_code_length_error'));
			}
			return schema.notRequired();
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	Company: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Azienda,
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	Codice_Fiscale__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Privato,
		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.length(
						16,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					)
					.matches(
						/^[A-Z0-9]{16}$/,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					);
			}
			if (isMarket(Markets.es)) {
				return schema.length(
					9,
					i18next.t('codice_fiscale_format_error_9_chars')
				);
			}
			return schema.notRequired();
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	FirstName: Yup.string().when('Clente__c', {
		is: (value: ClienteEnum) =>
			[ClienteEnum.Libero_Professionista, ClienteEnum.Privato].includes(value),
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	LastName: Yup.string().required(i18next.t('required_field')),
});

export const validationsLeadCreateForm = Yup.object().shape({
	Cliente__c: Yup.string().required(i18next.t('client_type_mandatory')),
	Email: Yup.string()
		.email(i18next.t('email_not_valid'))
		.required(i18next.t('email_mandatory')),
	Phone: Yup.string()
		.matches(
			/^\+?\d{1,3}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
			i18next.t('phone_not_valid')
		)
		.required(i18next.t('phone_mandatory')),
	City: Yup.string().required(i18next.t('city_mandatory')),
	Partita_Iva__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) =>
			[ClienteEnum.Azienda, ClienteEnum.Libero_Professionista].includes(value),
		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.length(11, i18next.t('business_fiscal_code_length_error_11_chars'))
					.matches(
						/^\d{11}$/,
						i18next.t('business_fiscal_code_length_error_11_chars')
					);
			}
			if (isMarket(Markets.es)) {
				return schema.length(9, i18next.t('business_fiscal_code_length_error'));
			}
			return schema.notRequired();
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	Company: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Azienda,
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	Codice_Fiscale__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Privato,
		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.length(
						16,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					)
					.matches(
						/^[A-Z0-9]{16}$/,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					);
			}
			if (isMarket(Markets.es)) {
				return schema.length(
					9,
					i18next.t('codice_fiscale_format_error_9_chars')
				);
			}
			return schema.notRequired();
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	FirstName: Yup.string().when('Clente__c', {
		is: (value: ClienteEnum) =>
			[ClienteEnum.Libero_Professionista, ClienteEnum.Privato].includes(value),
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	LastName: Yup.string().required(i18next.t('required_field')),
	LeadSource: Yup.string().required(i18next.t('required_field')),
	Marca__c: Yup.string().required(i18next.t('required_field')),
	Modello__c: Yup.string().required(i18next.t('model_required_field')),
	Fonte_di_acquisizione__c: Yup.string().when('LeadSource', {
		is: (value: string) => value?.toLowerCase() == 'store',
		then: () => Yup.string().required(i18next.t('required_field')),
		otherwise: (schema) => schema.notRequired(),
	}),
});
